import { ref } from 'vue'

interface Item {
  id: number
  name: string
}

export function useItems() {
  const items = ref<Item[]>([]) // items is now Ref<Item[]>
  const getItems = async (): Promise<Item[]> => {
    const response = await fetch('/items/')
    // Assert the response is OK
    if (!response.ok) {
      throw new Error('Failed to fetch items')
    }
    // Assert the response is JSON
    if (!response.headers.get('content-type')?.includes('application/json')) {
      throw new Error('Invalid content type')
    }

    return await response.json()
  }

  const fetchItems = async () => {
    items.value = await getItems()
  }

  return { items, fetchItems }
}
